<template>
  <div class="member_login_area">
    <div class="image">
      <img src="https://triple-crown.co.jp/wp-content/themes/triplecrown_v2/images/slide1.png" alt="" />
    </div>
    <div class="logo_area">
      <img src="/images/black_logo.png" alt="" /><br /><img src="/images/system.png" alt="" />
    </div>
    <div class="login_message">ようこそ、こちらよりログインしてください。</div>
    <div class="login_form">
      <div class="login_id_area">
        <el-input autocapitalize="off" placeholder="ログインID" v-model="login_id"></el-input>
      </div>
      <div class="password_area">
        <el-input placeholder="password" v-model="password" show-password></el-input>
      </div>
      <p class="error_message" v-if="error_message">
        <el-alert :title="error_message" effect="dark" :closable="false" type="error"> </el-alert>
      </p>
      <div class="login_btn_area">
        <el-button type="primary" @click="login" :loading="loginProcessing">ログインする</el-button>
      </div>
    </div>
    <el-dialog :visible.sync="sms.see" width="400px" :close-on-click-modal="false" :before-close="smsDialogCloseHandle">
      <div class="sms">
        <h2 class="sms__ttl"><i class="el-icon-lock sms__icon"></i> 認証コード入力</h2>
        <p class="sms__txt">届いた4桁のコードを入力してください。</p>
        <p class="error_message" v-if="sms.error_message">
          <el-alert :title="sms.error_message" effect="dark" :closable="false" type="error"> </el-alert>
        </p>
        <el-input type="tel" v-model="sms.val" maxlength="4" @input="smsInput" show-word-limit> </el-input>

        <el-button type="primary" class="sms__btn" @click.prevent="smsLogin">送信</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {setTimeout} from 'timers'
export default {
  name: 'login',
  data() {
    return {
      login_id: '',
      password: '',
      error_message: '',
      loginProcessing: false,
      sms: {
        val: '',
        see: false,
        error_message: ''
      },
      sms_count: 0
    }
  },
  mounted() {
    this.$store.state.login_page = true
    // this.$store.commit("auth/logout");
  },
  destroyed() {
    this.loginProcessing = false
  },
  methods: {
    login() {
      this.loginProcessing = true
      if (this.login_id && this.password) {
        axios
          .post('/api/store/login', {
            account: this.login_id,
            password: this.password
          })
          .then((res) => {
            if (res.data.sms) {
              if (res.data.send.code == '001') {
                this.sms.see = true
              } else {
                this.error_message = res.data.send.message
              }
            } else {
              // 二段階認証なし
              this.$store.commit('auth/login')
              this.$store.commit('auth/user', res.data.user)
              this.$router.push('/')
            }
          })
          .catch(() => {
            this.password = ''
            this.loginProcessing = false
            this.error_message = 'ログインIDまたはパスワードが間違っております'
          })
      } else {
        this.loginProcessing = false
        this.error_message = 'ログインID、パスワードは必ずご入力ください。'
      }
    },
    smsInput(val) {
      this.sms.val = this.sms.val.replace(/[^0-9]/g, '')
    },
    smsLogin() {
      if (this.sms.val) {
        axios
          .post('/api/store/login-sms', {
            account: this.login_id,
            password: this.password,
            code: this.sms.val
          })
          .then((res) => {
            if (res.data.sms) {
              // 二段階認証なし
              this.$store.commit('auth/login')
              this.$store.commit('auth/user', res.data.user)
              this.$router.push('/')
            } else {
              this.sms.val = ''
              this.sms.error_message = '認証コードが間違っております。'
              this.sms_count++
              if (this.sms_count >= 3) {
                this.$alert('再度最初からやり直してください。', '', {
                  confirmButtonText: 'OK',
                  center: true,
                  callback: (action) => {
                    this.smsClose()
                  }
                })
              }
            }
          })
      } else {
        this.sms.error_message = '認証コードを必ずご入力してください。'
      }
    },
    smsDialogCloseHandle(done) {
      this.loginProcessing = false
      done()
    },
    smsClose() {
      this.sms.see = false
      this.loginProcessing = false
      this.sms.error_message = ''
      this.sms_count = 0
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';
.member_login_area {
  margin-top: 0px;
  margin-bottom: 40px;
  .image {
    padding-bottom: 30px;
    margin-left: -20px;
    margin-right: -20px;
    margin-top: -110px;
    img {
      width: 100%;
      border-bottom: 1px solid #eee;
    }
  }
  .logo_area {
    text-align: center;
  }
  .login_message {
    margin-top: 30px;
    font-size: 16px;
    color: #82838d;
    text-align: center;
  }
  .login_form {
    margin-top: 50px;
    margin-left: 120px;
    margin-right: 120px;
  }
  .login_id_area {
    margin-bottom: 15px;
  }
  .login_btn_area {
    margin-top: 30px;
    text-align: right;
    .el-button {
      display: block;
      width: 100%;
    }
  }
  .error_message {
    margin-top: 10px;
  }
  .sms {
    text-align: center;
  }
  .sms__ttl {
    font-size: 25px;
    color: $--color-primary;
  }
  .sms__icon {
    font-size: 30px;
  }
  .sms__txt {
    font-size: 14px;
  }
  .sms__form {
    max-width: 148px;
    width: 100%;
    margin: 0 auto;
  }
  .sms__btn {
    width: 100%;
    margin-top: 20px;
  }
}
</style>
